function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import { strictSpace } from '../../utils';
import styledPropTypes from '@styled-system/prop-types';
/**
 * Renders a responsive video container at 16:9
 */

var VideoContainer = styled.div.withConfig({
  displayName: "VideoContainer",
  componentId: "sc-a9vqq4-0"
})(["position:relative;padding-top:0;padding-bottom:56.25%;height:0;", " iframe{position:absolute;top:0;left:0;width:100%;height:100%;}"], strictSpace);
VideoContainer.propTypes = _objectSpread({}, styledPropTypes.space);
VideoContainer.defaultProps = {
  mb: 'xs'
};
/** @component */

export default VideoContainer;